export default "__VITE_ASSET__C4KowfmC__"